/**
 * Check if an array is array of objets
 */
const isArrayOfObjects = <T extends object>(array: unknown): array is T[] => {
  return Array.isArray(array) && array.every((item) => typeof item === 'object' && item !== null);
};

export default isArrayOfObjects;
